export const SEARCH_DATA_LOADING = "SEARCH_DATA_LOADING";
export const SEARCH_DATA_SUCCESS = "SEARCH_DATA_SUCCESS";
export const SEARCH_DATA_ERROR = "SEARCH_DATA_ERROR";
